import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { Router } from '@angular/router';
import { ErrorDialogComponent } from '../shared/error-dialog/error-dialog.component';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
 private isSessionExpired = false;
  errorModalRef: MDBModalRef;
  constructor(private router: Router, private mdbModalService: MDBModalService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      var token: any; 
      var user: any;
      user = JSON.parse(sessionStorage.getItem('user'));
        token = JSON.parse(JSON.stringify(""+user));
  //console.log(user.username + user.userToken);
     if(user != null)
     {
        request = request.clone({
          setHeaders: {
            Authorization: `${user.TokenId}`
          }
        });
     }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {

    
        if (error.status === 401 && !this.isSessionExpired) {

          this.isSessionExpired = true;

          sessionStorage.clear();

          const message = 'Session expired. Please login again.';

          this.errorModalRef = this.mdbModalService.show(
            ErrorDialogComponent,
            {
              data: {
                message: message,
                data: []
              },
              backdrop: 'static',
              keyboard: false
            }
          );

          this.errorModalRef.content.action.subscribe(result => {
            if (result === 'OK') {
              this.errorModalRef.hide();
              this.router.navigate(['/login']);
            }
          });
        }
        return throwError(() => error);
      })
    );
  }
}
